import React, { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import BlueButton from "../../../../components/BlueButton/BlueButton";
import AddGif from "./../../../../assets/add-gif.gif";
import DeleteUser from "./../../../../assets/delete.svg";

import api from "../../../../utils/api";
import { toast } from "react-toastify";
import MessageModals from "../../../../components/MessageModals/MessageModals";
import CreateEditUnits from "./CreateEditUnits/CreateEditUnits";

const UnitsSection = ({ isMobile, isTablet }) => {
  // State for units data
  const [units, setUnits] = useState([]);
  const [loading, setLoading] = useState(false);

  // State for modals
  const [modalOpen, setModalOpen] = useState(false);
  const [currentView, setCurrentView] = useState("");
  const [selectedUnit, setSelectedUnit] = useState(null);

  // State for message modal
  const [isMessageOpen, setIsMessageOpen] = useState(false);
  const [messageView, setMessageView] = useState("");
  const [deleteMessage, setDeleteMessage] = useState("");

  // Fetch units on component mount and when refresh is needed
  const [refreshData, setRefreshData] = useState(false);

  useEffect(() => {
    fetchUnits();
  }, [refreshData]);

  // Function to trigger data refresh
  const handleDataRefresh = () => {
    setRefreshData((prev) => !prev); // Toggle to trigger useEffect
  };

  // Function to fetch units from API
  const fetchUnits = async () => {
    setLoading(true);
    try {
      const response = await api.get("/variations?type=unit");
      setUnits(response.data.data || []);
    } catch (error) {
      toast.error(error?.message || "فشل في تحميل الوحدات");
    } finally {
      setLoading(false);
    }
  };

  // Function to handle opening the modal
  const handleOpen = (view, unit = null) => {
    setCurrentView(view);
    setSelectedUnit(unit);
    setModalOpen(true);
  };

  // Function to handle opening message modal for deletion
  const handleOpenDelete = (unit) => {
    setSelectedUnit(unit);
    setMessageView("delete");
    setDeleteMessage("تم حذف الوحدة بنجاح");
    setIsMessageOpen(true);
  };

  const actionColumn = [
    {
      field: "index",
      headerName: "#",
      minWidth: 40,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "name_ar",
      headerName: "اسم الوحدة بالعربية",
      minWidth: 160,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "name_en",
      headerName: "اسم الوحدة بالانجليزية",
      minWidth: 160,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "action",
      headerName: "",
      minWidth: 160,
      headerAlign: "start",
      align: "start",
      flex: 1,
      renderCell: (params) => {
        return (
          <div className="cell-action" style={{ justifyContent: "flex-end" }}>
            <div
              className="cell-btn edit-btn"
              onClick={() => handleOpen("editUnit", params?.row)}
            >
              <i className="fas fa-edit"></i>
            </div>
            <div
              className="cell-btn"
              onClick={() => handleOpenDelete(params?.row)}
            >
              <img src={DeleteUser} alt="" />
            </div>
          </div>
        );
      },
    },
  ];

  return (
    <>
      <div className="view-title-action">
        <p className="view-title">اعدادات وحدات اضافة منتجات</p>
        <BlueButton
          text="اضافة وحدة جديدة"
          size={isMobile ? "full" : isTablet ? "fit" : "large"}
          variant="fill"
          onClick={() => handleOpen("createUnit")}
          icon={<img src={AddGif} alt="" />}
        />
      </div>

      <DataGrid
        sx={{ backgroundColor: "white", width: "100%" }}
        autoHeight={true}
        columns={actionColumn}
        rows={units.map((row, index) => ({
          ...row,
          index: index + 1,
          id: row?.id || index, // Ensure each row has a unique id
        }))}
        disableVirtualization
        disableColumnFilter
        disableColumnMenu
        hideFooter
        loading={loading}
      />

      {/* Unit Create/Edit Modal */}
      <CreateEditUnits
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        onOpen={() => setModalOpen(true)}
        currentView={currentView}
        initialData={selectedUnit}
        onSuccess={handleDataRefresh}
      />

      {/* Message Modal for Delete Confirmation */}
      <MessageModals
        open={isMessageOpen}
        onClose={() => {
          setIsMessageOpen(false);
          setSelectedUnit(null);
          setDeleteMessage("");
        }}
        text={deleteMessage}
        currentView={messageView}
        route={`/variations/${selectedUnit?.id}`}
        onDataChange={handleDataRefresh}
      />
    </>
  );
};

export default UnitsSection;
